import { makeAutoObservable } from 'mobx';
import { getCookie, setCookie } from './MeasurementHelper';
import { unitsMapping } from './MeasurementEnums';

export interface IMeasurementStore {
  save(cookie: unitsMapping): void;
  unitsMapping: unitsMapping;
}


export default class MeasurementsStore implements IMeasurementStore {
  unitsMapping: unitsMapping = getCookie();

  constructor() {
    makeAutoObservable(this);
  }

   save(unitsMapping: unitsMapping) {
     this.unitsMapping = unitsMapping;
     setCookie(unitsMapping);
  }
}
